<script setup lang="ts">
import DataStateButton from 'pejer/src/components/DataState/DataStateButton.vue'
import { cn } from 'pejer/src/lib/utils'
import { DataState } from 'pejer/src/types/types'

const props = defineProps<{
  grossAmount: number
  currency: string
  dataState: DataState
  class?: string
}>()

function getAmountString() {
  return new Intl.NumberFormat('no-NO', {
    style: 'currency',
    currency: props.currency,
    minimumFractionDigits: 2,
  }).format(props.grossAmount / 100)
}
</script>
<template>
  <DataStateButton
    :data-state="dataState"
    type="submit"
    :class="
      cn(
        'w-full p-3 h-fit rounded-sm group transition-all duration-400 hover:scale-[102%]',
        props.class
      )
    "
    error-class="flex-col-reverse w-full"
  >
    <!-- bg-indigo-500 hover:bg-indigo-600 hover:shadow-indigo-200 -->
    <!-- :class="cn('w-full p-3 h-fit rounded-sm bg-[#0f26a0]/80 hover:bg-[#0f26a0]', props.class)" -->
    <span id="stripe-button-text" class="font-semibold text-base text-white flex gap-2">
      <slot name="text" :amount="getAmountString()"> Betal {{ getAmountString() }} </slot>
    </span>
  </DataStateButton>
</template>
